import { mixed, object } from "yup";

import { templateAssetValidationSchema } from "@dzambalaorg/mui-inputs-asset";
import { MergeStatus } from "@framework/types";

export const mergeValidationSchema = object().shape({
  item: templateAssetValidationSchema,
  price: templateAssetValidationSchema,
  mergeStatus: mixed<MergeStatus>().oneOf(Object.values(MergeStatus)).required("form.validations.valueMissing"),
});
